// you can import modules from the theme lib or even from
// NPM packages if they support it…
import '../../assets/js/vendors/jquery.cookieBar.min.js'; // for header topbar
import scrollHeader from "./components/header";
import SwiperCarousel from "./components/swiper-carousel";
import SwiperCarouselSmall from "./components/swiper-carouselSmall";
import contactModal from "./components/contact-modal";
import cookieBar from "./components/cookie";
import partnerFilter from "./components/partner-filter";
import tabs from "./components/tabs";
import tabsVertical from "./components/tabsVertical";
import teamModal from "./components/team-modal";
import video from "./components/video";
import media from "./components/media";
import modules from "./components/modules";
import careersApi from "./components/careers";
// you can also require modules if they support it…
//const ExampleModule2 = require("./components/example-2");

// Some convenient tools to get you started…
//import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
import AnimateOnPageLinks from "./components/AnimateOnPageLinks";
import {handleDropdowns} from "./components/dropdowns";
import {handlePartnerSearch} from "./components/partner-search";

// Initialise our components on jQuery.ready…
jQuery(function ($) {
  SwiperCarousel.init();
  SwiperCarouselSmall.init();
  contactModal.init();
  cookieBar.init();
  tabs.init();
  tabsVertical.init();
  partnerFilter.init();
  teamModal.init();
  video.init();
  media.init();
  modules.init();
  scrollHeader.init(); // show hide header
  AnimateOnPageLinks.init();
  careersApi.init();
  handleDropdowns()
  handlePartnerSearch()
});
